import React, { useState } from "react";
import { Paper, useTheme, useMediaQuery, Box, IconButton, Typography } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MapProtectedRainforestArea } from "types/map";
import MapLegendRainforestPanelCorridors from "./MapLegendRainforestPanelCorridors";
import MapLegendRainforestPanelRegions from "./MapLegendRainforestPanelRegions";
import MapLegendRainforestPanelHumans from "./MapLegendRainforestPanelHumans";

type Props = {
  protectedRegions: MapProtectedRainforestArea[];
  protectedCorridors: MapProtectedRainforestArea[];
  protectedHumans: MapProtectedRainforestArea[];
  hiddenCorridorIndices: number[];
  highlightHumans: boolean;
  onToggleCorridor: (index: number) => void;
  onToggleHumans: () => void;
};

const MapLegendRainforestPanel = ({
  protectedRegions,
  protectedCorridors,
  protectedHumans,
  hiddenCorridorIndices,
  highlightHumans,
  onToggleCorridor,
  onToggleHumans,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Paper
      elevation={4}
      sx={{
        padding: isMobile ? 1.5 : 2.5,
        borderRadius: 1,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        pointerEvents: "auto",
        minWidth: 300,
        maxWidth: isMobile ? 255 : 320,
        display: "flex",
        flexDirection: "column",
        gap: isExpanded ? (isMobile ? 1 : 2) : 0,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6" sx={{ fontSize: "1rem", fontWeight: 700 }}>
          Areas
        </Typography>
        <IconButton size="small" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isExpanded && (
        <>
          <MapLegendRainforestPanelCorridors
            protectedCorridors={protectedCorridors}
            hiddenCorridorIndices={hiddenCorridorIndices}
            onToggleCorridor={onToggleCorridor}
            isMobile={isMobile}
          />

          <MapLegendRainforestPanelRegions
            protectedRegions={protectedRegions}
            isMobile={isMobile}
          />

          <MapLegendRainforestPanelHumans
            protectedHumans={protectedHumans}
            highlightHumans={highlightHumans}
            onToggleHumans={onToggleHumans}
            isMobile={isMobile}
          />
        </>
      )}
    </Paper>
  );
};

export default MapLegendRainforestPanel;
